import { Injectable, EventEmitter } from '@angular/core';
import { windowsStore } from 'process';
import { ElectronService } from './electron.service';

// import { readFileSync } from 'fs';
// const fs = require('fs');

@Injectable({
  providedIn: 'root'
})
export class CommonService {

  alerts: any = [];
  basepath: any;
  fs: any;
  loading: boolean = false;
  confirmData: any = {
    title: '',
    content: '',
    cancelTitle: '',
    confirmTitle: '',
    present: false
  };
  confirmReturn: EventEmitter<any> = new EventEmitter();

  constructor(
    public electronService: ElectronService
  ) { 
    if(this.electronService.isElectron) {
      this.fs = window.require('fs');
    }
  }

  // 알럿 관련
  success(msg):  void {this.alertGo('success',msg)}
  info(msg):     void {this.alertGo('info',msg)}
  warning(msg):  void {this.alertGo('warning',msg)}
  danger(msg):    void {this.alertGo('danger',msg)}
  alertGo(type,msg) {
    this.alerts.push({
      type: type,
      msg: msg,
      timeout: 3000
    });
  }

  async confirm(val) {
    this.confirmData = {
      title: val.title,
      content: val.content,
      cancelTitle: val.cancelTitle,
      confirmTitle: val.confirmTitle,
      isAlert: false,
      present: true
    };
    
    return new Promise((resolve) => {
      this.confirmReturn.subscribe((data) => {
        resolve(data);
      });
    });
  }

  async alert(val) {
    this.confirmData = {
      title: val.title,
      content: val.content,
      cancelTitle: val.cancelTitle,
      confirmTitle: val.confirmTitle,
      isAlert: true,
      present: true
    };
    
    return new Promise((resolve) => {
      this.confirmReturn.subscribe((data) => {
        resolve(data);
      });
    });
  }

  getDocumentPath() {
    return new Promise((resolve,reject) => {
      let info: any = this.electronService.ipcRenderer.sendSync("getDocumentPath");
      resolve(info.path);
    });
  }

  inputPhoneNumber(str:string) {
    var number = str.replace(/[^0-9]/g, "");
    var phone = "";

    if(number.length < 4) {
        return number;
    } else if(number.length < 7) {
        phone += number.substr(0, 3);
        phone += "-";
        phone += number.substr(3);
    } else if(number.length < 11) {
        phone += number.substr(0, 3);
        phone += "-";
        phone += number.substr(3, 3);
        phone += "-";
        phone += number.substr(6);
    } else {
        phone += number.substr(0, 3);
        phone += "-";
        phone += number.substr(3, 4);
        phone += "-";
        phone += number.substr(7);
    }
    return phone;
  }

  readTextFile(file) {
    return new Promise(resolve => {
      try {
        var body = this.fs.readFileSync(file);
        resolve(body);
      } catch (err) {
        resolve('');
      }
    });
  }

  readImageFile(file) {
    return new Promise(resolve => {
      var body = this.fs.readFileSync(file);
      resolve(body.toString('base64'));
    });
  }

  saveFile(param) {
    this.fs.writeFile(param.path, param.content, (err) => {});
  }

  removeFile(path) {
    this.fs.unlink(path, (err) => {});

  }
  
  saveBase64File2(param) {
    return new Promise(resolve => {
      this.fs.writeFileSync(param.path, param.content, 'base64');
      resolve(true);
    });
  }

  chkByte(str) {

    var str_len = str.length;
    var rbyte = 0;
    var one_char = "";

    for(var i=0; i<str_len; i++) {
      one_char = str.charAt(i);
      if(escape(one_char).length > 4) {
          rbyte += 2;                                         //한글2Byte
      }else{
          rbyte++;                                            //영문 등 나머지 1Byte
      }
    }
    return rbyte;
  }

  emailCheck(email) {
    var regex=/([\w-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([\w-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/;
    return (email != '' && email != 'undefined' && regex.test(email));
  }
  
  phoneCheck(phone) {
    var regex = /^[0-9]{2,3}-[0-9]{3,4}-[0-9]{4}/;
    return (phone != '' && phone != 'undefined' && regex.test(phone));
  }

  openBrowser(url) {

    if(this.electronService.isElectron) {
      let arg = {
        link: url
      }
      this.electronService.ipcRenderer.sendSync("browserOpenLink",arg);
      return;
    }

    window.open(url);
    
  }
}
